import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { backendApis } from '@/backendApis';

const growthKeys = {
  wrapped: (start?: string, end?: string) =>
    ['growth', 'wrapped', start, end] as const,
  wrappedShare: (shareId: string) =>
    ['growth', 'wrapped', 'share', shareId] as const,
};

const WRAPPED_STALE_TIME_MS = 5 * 60_000;

export const useWrappedQuery = (periodStart?: string, periodEnd?: string) =>
  useQuery({
    queryKey: growthKeys.wrapped(periodStart, periodEnd),
    queryFn: () => backendApis.growth.getWrapped(periodStart, periodEnd),
    staleTime: WRAPPED_STALE_TIME_MS,
  });

export const useWrappedQueryPrefetch = (
  periodStart?: string,
  periodEnd?: string
) => {
  const qc = useQueryClient();
  useEffect(() => {
    qc.prefetchQuery({
      queryKey: growthKeys.wrapped(periodStart, periodEnd),
      queryFn: () => backendApis.growth.getWrapped(periodStart, periodEnd),
      staleTime: WRAPPED_STALE_TIME_MS,
    });
  }, [qc, periodStart, periodEnd]);
};

export const useWrappedShareQuery = (shareId: string) =>
  useQuery({
    queryKey: growthKeys.wrappedShare(shareId),
    queryFn: () => backendApis.growth.getSharedWrapped(shareId),
    staleTime: WRAPPED_STALE_TIME_MS,
    retry: false,
  });

export const useCreateWrappedShareMutation = (
  periodStart?: string,
  periodEnd?: string
) =>
  useMutation({
    mutationFn: () => backendApis.growth.createShare(periodStart, periodEnd),
  });
